import React from "react";
import { HiArrowRight } from "react-icons/hi";

export default function DesktopSidebar({
  // data
  business,
  selectedReviews,
  pricePerDeletion,

  // tier + progress
  activeTier,
  reviewsLeftForNextTier,
  saveAmount,
  getProgressPercentage,

  // behavior
  currentStep, // 2 or 3
  nextStep, // only used on step2
  isSubmitting = false, // only used on step3 (optional)
}) {
  return (
    <div className="hidden md:flex fixed top-0 right-0 h-screen w-[28%] bg-gray-100 flex-col">
      {/* Scrollable content */}
      <div className="h-[calc(100vh-220px)] overflow-y-auto overflow-hidden p-5 flex flex-col gap-4">
        {/* Coupon Code & Price */}
        <div className="border rounded bg-white p-5">
          <div className="flex gap-0">
            <input
              type="text"
              placeholder="Gutschein eingeben"
              className="flex-1 border rounded-l-xl px-4 py-2 outline-none"
            />
            <button className="bg-[#0b2b40] text-white rounded-r-xl px-4">
              einlösen
            </button>
          </div>

          {activeTier < 2 && reviewsLeftForNextTier >= 0 && (
            <p className="text-sm text-gray-500 mt-1">
              Nur noch {reviewsLeftForNextTier} <strong>Bewertungen</strong>
              {reviewsLeftForNextTier !== 1 && "s"} für die günstigere Preisstaffelung
            </p>
          )}

          {/* Progress Bar */}
          <div className="mt-4">
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#0b2b40] transition-all duration-500 ease-out"
                style={{ width: `${getProgressPercentage()}%` }}
              />
            </div>
          </div>

          {activeTier < 2 && saveAmount > 0 && (
            <p className="text-sm text-bold mt-1 text-gray-500 italic">
              Sparen Sie €{saveAmount} bei der nächsten Stufe
            </p>
          )}

          <div className="grid grid-cols-2 gap-2 mt-2">
            {[0, 1, 2].map((tier) => (
              <div
                key={tier}
                className={`border py-3 px-1 pl-2 rounded-xl text-left cursor-pointer ${
                  activeTier === tier
                    ? "bg-[#3c6e711a] text-gray-800 border-1 border-[#3c6e71]"
                    : "bg-white"
                }`}
              >
                <p className="text-sm text-gray-600">
                  {tier === 0
                    ? "Bis zu 5 Löschungen"
                    : tier === 1
                    ? "Ab 6 Löschungen"
                    : "Ab 10 Löschungen"}
                </p>
                <p className="text-sm font-semibold text-gray-800">
                  €{tier === 0 ? 129 : tier === 1 ? 89 : 79},00
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Company Info */}
        <div className="border p-3 rounded-xl bg-gray-50 flex flex-col gap-2 mt-2">
          <span className="text-sm text-gray-400">
            Im Falle einer erfolgreichen Löschung der von Ihnen gemeldeten Bewertungen könnte
            Ihre Google-Bewertung das folgende Rating aufweisen:
          </span>
          <img
            src={business?.photoUrl}
            alt="Company"
            className="w-full h-24 object-cover rounded-md"
          />
          <p className="font-semibold">{business?.name?.text}</p>
          <p>
            Potenzielle Verbesserung auf:{" "}
            <span className="font-bold">{business?.newRating ?? "—"} ★</span>
          </p>
          <p className="text-sm text-gray-500">({selectedReviews.length} selected)</p>
        </div>

        {/* BEST OPTION card - left exactly as-is, but we keep it in the component */}
        <div className="max-w-sm mx-auto">
          <div className="relative rounded-3xl border border-green-400 bg-gradient-to-br from-green-100 via-green-50 to-white shadow-2xl overflow-hidden transform hover:scale-105 transition-transform duration-500">
            {/* BEST OPTION BADGE */}
            <div className="absolute top-0 left-0">
              <div className="bg-green-500 text-white text-xs font-bold px-4 py-1 rounded-br-2xl flex items-center gap-1 shadow-md">
                ✓ BESTE OPTION
              </div>
            </div>

            {/* CONTENT */}
            <div className="p-6 pt-12 text-center relative z-10">
              {/* TITLE */}
              {activeTier === 0 && (
                <p className="text-gray-800 text-lg font-semibold">
                  Ab <span className="font-boldtext-[#8ec700]">6 Löschungen</span>
                </p>
              )}
              {activeTier === 1 && (
                <p className="text-gray-800 text-lg font-semibold">
                  Ab <span className="font-boldtext-[#8ec700]">10 Löschungen</span>
                </p>
              )}

              {/* PRICE */}
              {activeTier === 0 && (
                <div className="text-5xl font-extrabold text-gray-900 my-4">€ 89</div>
              )}
              {activeTier === 1 && (
                <div className="text-5xl font-extrabold text-gray-900 my-4">€ 79</div>
              )}

              {/* DISCOUNT */}
              {activeTier === 0 && (
                <div className="inline-flex items-center gap-3 bg-green-400 text-white text-sm px-4 py-2 rounded-full mb-4 shadow-sm">
                  <span className="relative font-bold text-lg text-white">
                    € 129
                    <span className="absolute left-0 top-1/2 w-full h-[1px] bg-black transform -translate-y-1/2"></span>
                  </span>
                  <span className="font-semibold text-base">€ 89</span>
                  <span className="font-bold ml-1">Sie sparen</span>
                  <span className="bg-green-200 text-green-800 text-xs font-semibold px-2 py-0.5 rounded-full">
                    –31%
                  </span>
                </div>
              )}

              {activeTier === 1 && (
                <div className="inline-flex items-center gap-3 bg-green-400 text-white text-sm px-4 py-2 rounded-full mb-4 shadow-md">
                  <span className="relative font-bold text-lg text-white">
                    € 89
                    <span className="absolute left-0 top-1/2 w-full h-[1px] bg-black transform -translate-y-1/2"></span>
                  </span>
                  <span className="font-semibold text-base">€ 79</span>
                  <span className="font-bold ml-1">Sie sparen</span>
                  <span className="bg-black text-white text-sm font-semibold px-2 py-0.5 rounded-full">
                    –39%
                  </span>
                </div>
              )}

              {/* WARNING */}
              <div className="flex items-center justify-center gap-2 text-sm text-gray-700 border-t border-dashed pt-4 mt-4">
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-green-500 text-white text-xs font-bold">
                  !
                </div>
                {activeTier < 2 && reviewsLeftForNextTier >= 0 && (
                  <p className="text-gray-600 leading-tight">
                    Nur noch <strong>{reviewsLeftForNextTier} Bewertung</strong>
                    {reviewsLeftForNextTier !== 1 && "en"} für die günstigere Preisstaffelung
                  </p>
                )}
              </div>

              {/* PRICE + RATING */}
              <div className="mt-6">
                <p className="text-xl font-semibold text-gray-900">
                  €{pricePerDeletion.toFixed(2)}{" "}
                  <span className="text-yellow-400">→ ★★★★★</span>
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  Gesamtbetrag:{" "}
                  <span className="font-semibold text-gray-700">
                    €{(selectedReviews.length * pricePerDeletion).toFixed(2)}
                  </span>
                </p>
              </div>

              {/* FEATURES */}
              <div className="mt-6 space-y-3 text-left text-sm text-gray-700">
                <div className="flex items-center gap-2">
                  <span className="text-green-500">✔</span>
                  Zahlung nur bei erfolgreicher Löschung
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-green-500">✔</span>
                  Keine Vorauszahlung
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-green-500">✔</span>
                  DSGVO-konform
                </div>
              </div>
            </div>

            {/* Background Overlay for Depth */}
            <div className="absolute inset-0 bg-gradient-to-t from-green-50 via-white to-transparent opacity-30 pointer-events-none rounded-3xl"></div>
          </div>
        </div>
      </div>

      {/* Fixed bottom section */}
      <div className="absolute bottom-0 left-0 right-0 p-5 bg-gray-100 border-t">
        <div className="border p-3 rounded-xl bg-gray-100">
          <div className="flex justify-between align-center">
            <p className="text-lg text-gray-600 font-bold">Preis pro Löschung</p>
            <h2 className="text-[#0b2b40] text-2xl font-bold">
              €{pricePerDeletion.toFixed(2)}
            </h2>
          </div>
          <div className="flex justify-between align-center">
            <p className="text-sm font-bold">Gesamtsumme </p>
            <p className="text-sm text-gray-600">
              €{(selectedReviews.length * pricePerDeletion).toFixed(2)}
            </p>
          </div>
        </div>

        {currentStep === 2 && (
          <button
            onClick={nextStep}
            disabled={selectedReviews.length === 0}
            className={`w-full py-3 font-semibold rounded-full transition flex gap-8 items-center justify-between px-4
              ${
                selectedReviews.length === 0
                  ? "bg-[#0b2b40] bg-opacity-40 cursor-not-allowed"
                  : "bg-[#0b2b40] hover:opacity-90 text-white"
              }`}
          >
            Jetzt risikofrei starten
            <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
              <HiArrowRight className="text-lg transform -rotate-24" />
            </span>
          </button>
        )}

        {currentStep === 3 && (
          <button
            type="submit"
            form="customer-form"
            disabled={isSubmitting}
            className={`w-full py-3 font-semibold rounded-full transition flex gap-8 items-center justify-between px-4
              ${
                isSubmitting
                  ? "bg-[#0b2b40] bg-opacity-40 cursor-not-allowed text-white"
                  : "bg-[#0b2b40] hover:opacity-90 text-white"
              }`}
          >
            Absenden
            <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
              <HiArrowRight className="text-lg transform -rotate-24" />
            </span>
          </button>
        )}

        <div className="text-center flex align-center justify-center">
          <p className="text-xs text-gray-500 mt-1 w-[70%] text-center align-centet flex justify-center">
            Kosten entstehen lediglich für Bewertungen, deren Entfernung erfolgreich war.
          </p>
        </div>
      </div>
    </div>
  );
}
